module.exports = __webpack_public_path__ + "img/nav-right-with-contact-black-chevy.348360d0.png";